import { z } from 'zod';

import filterBySchema from './filterBySchema';

/**
 * Parses data as an array and removes any items that fail to parse
 *
 * Ej.
 *
 * ```ts
 * const parseNumbers = filterByArraySchema(z.number());
 * parseNumbers(["a", 1, "c", 3, false]); // [1, 3]
 * ```
 * @returns
 */
export default function filterByArraySchema<TData>(schema: z.ZodSchema) {
  return function (data: unknown) {
    const parser = filterBySchema<TData>(schema);
    const UnknownArray = z.array(z.unknown()).transform(parser);
    const parsedUnknownArray = UnknownArray.safeParse(data);

    if (!parsedUnknownArray.success) return [];

    return parsedUnknownArray.data;
  };
}
